import { create } from "zustand";

import { Playlist } from "../types/playlist.types";
import { getFormattedPlaylist, getFormattedPlaylists } from "./general.helper";
import { Song } from "../types/song.types";

interface PlaylistStore {
  playlists: Playlist[];
  setPlaylists: (playlists: Playlist[]) => void;
  addNewPlaylist: (playlist: Playlist) => void;
  updatePlaylist: (playlist: Playlist, id: string) => void;
  addLikedSongToPlaylist: (song: Song) => void;
  removeUnLikedSongFromPlaylist: (song: Song) => void;
}

const playlistStore = create<PlaylistStore>((set) => ({
  playlists: [],

  setPlaylists: (playlists) => {
    set((state) => {
      return {
        ...state,
        playlists: getFormattedPlaylists(playlists),
      };
    });
  },

  addNewPlaylist: (playlist) => {
    set((state) => {
      return {
        ...state,
        playlists: [getFormattedPlaylist(playlist), ...state.playlists],
      };
    });
  },

  updatePlaylist: (data, id) => {
    set((state) => {
      const newPlaylists = state.playlists.map((p) => {
        if (p.id === id) {
          return {
            ...p,
            ...data,
          };
        }
        return p;
      });
      return {
        ...state,
        playlists: newPlaylists,
      };
    });
  },

  //! confirm this
  addLikedSongToPlaylist: (song) => {
    set((state) => {
      const newPlaylists = state.playlists.map((p) => {
        if (p.is_favorite) {
          const exist = p.songs.find((s) => s.id === song.id);
          if (exist) {
            return p;
          }

          return {
            ...p,
            songs: [song, ...p.songs],
          };
        }
        return p;
      });
      return {
        ...state,
        playlists: newPlaylists,
      };
    });
  },

  removeUnLikedSongFromPlaylist: (song) => {
    set((state) => {
      const newPlaylists = state.playlists.map((p) => {
        if (p.is_favorite) {
          const newSongs = p.songs.filter((s) => s.id !== song.id);
          return {
            ...p,
            songs: newSongs,
          };
        }
        return p;
      });
      return {
        ...state,
        playlists: newPlaylists,
      };
    });
  },
}));

export default playlistStore;
